import React, { useState } from 'react';
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Plus, Heart, ArrowRight, Sparkles, Dog, PawPrint, X, ImagePlus, Camera, ArrowLeft, Calendar, HomeIcon, Activity, Clock } from "lucide-react";
import { motion, AnimatePresence } from 'framer-motion';
import { useAnalysis } from '../AnalysisContext'
import { set } from 'date-fns';
import { cn } from "@/lib/utils";
import WelcomeView from "./welcome/WelcomeView";
import NameInputView from "./welcome/NameInputView";
import PhotoUploadView from "./welcome/PhotoUploadView";
import ContextView from "./welcome/ContextView";
import AnalysisTypeView from "./welcome/AnalysisTypeView";

const WelcomeAnalysisModal = ({
    isOpen,
    onOpenChange,
    previousPets = [],
    onSelectPet,
    onNewAnalysis,
    setPetSelected,
    setFiles,
    setUserContext,
    analysisType,
    setAnalysisType,
    onSubmit
}) => {
    const [view, setView] = useState('main'); 
    const [files, setCurrentFiles] = useState([]);
    const [currentPetName, setCurrentPetName] = useState('');
    const { setPetName } = useAnalysis();
    const [userCurrentContext, setUserCurrentContext] = useState(''); 

    const handleNewIntegrant = () => {
        setView('name');
    };

    const handleBack = () => {
        setView('main');
        setCurrentPetName('');
    };

    const handleBackPhotos = () => {
        setView('photos');
    };


    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && currentPetName.trim()) {
            handleConfirmName();
        }
    };

    // Modify your handlers to include the photo step
    const handleConfirmName = () => {
        if (currentPetName.trim()) {
            setView('photos');
            setPetName(currentPetName);
        }
    };

    const onSelectPetView = (pet) => {
        setCurrentPetName(pet.name);
        setPetName(pet.name);
        setView('photos');
    };

    const handleSubmitPhotos = () => {
        //onNewAnalysis('named', currentPetName);
        //setPetSelected(true);
        //onOpenChange(false);
        setView('context');
    };

    const handlePhotoBack = () => {
        // If we came from name input, go back to name
        setView('main');
        setCurrentPetName('');
        setCurrentFiles([]);
        setFiles([]);
    };

    const handleBackContext = () => {
        setView('context');
    };

    // Add handlers for files
    const handleFileUpload = (e) => {
        const newFiles = Array.from(e.target.files);
        const remainingSlots = 5 - files.length;
        const filesToAdd = newFiles.slice(0, remainingSlots);
        setCurrentFiles([...files, ...filesToAdd]);
        setFiles([...files, ...filesToAdd]);
    };

    const removeFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
        setCurrentFiles(files.filter((_, i) => i !== index));
    };

    const onContinue = () => {
        setUserContext(userCurrentContext);
        setView('analisisType');
    }


    const handleSubmit = (e) => {
        if (e) {
            e.preventDefault(); 
        }
        onSubmit(e);
    };
    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-3xl max-w-[92vw] p-0 gap-0 bg-gradient-to-b from-amber-50/70 to-white rounded-2xl border-0 shadow-xl overflow-hidden max-h-[90vh]">
            <div className="h-full overflow-y-auto"> {/* Allow scrolling in the parent */}
                <AnimatePresence mode="wait">
                    {view === 'main' ? (
                        <WelcomeView
                            previousPets={previousPets}
                            onSelectPetView={onSelectPetView}
                            handleNewIntegrant={handleNewIntegrant}
                            onNewAnalysis={onNewAnalysis}
                            setPetSelected={setPetSelected}
                        />
                    ) : view === 'name' ? (
                        <NameInputView
                            handleBack={handleBack}
                            currentPetName={currentPetName}
                            setCurrentPetName={setCurrentPetName}
                            handleKeyPress={handleKeyPress}
                            handleConfirmName={handleConfirmName}
                        />
                    ) : view === 'photos' ? (
                        <PhotoUploadView
                            handleBack={handlePhotoBack}
                            setView={setView}
                            currentPetName={currentPetName}
                            files={files}
                            removeFile={removeFile}
                            handleFileUpload={handleFileUpload}
                            handleSubmitPhotos={handleSubmitPhotos}
                        />
                    ) : view === 'context' ? (
                        <ContextView
                            handleBack={handleBackPhotos}
                            petName={currentPetName}
                            setCurrentPetName={setCurrentPetName}
                            handleKeyPress={handleKeyPress}
                            handleConfirmName={handleConfirmName}
                            setUserContext={setUserContext}
                            onContinue={onContinue}
                            userCurrentContext={userCurrentContext}
                            setUserCurrentContext={setUserCurrentContext}
                        />
                    ) : (
                        <AnalysisTypeView
                            handleBack={handleBackContext}
                            analysisType={analysisType}
                            setAnalysisType={setAnalysisType}
                            onSubmit={handleSubmit}
                            petName={currentPetName}
                        />
                    )}
                </AnimatePresence>
            </div>
        </DialogContent>
    </Dialog>
    );
};

export default WelcomeAnalysisModal;
